var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrossedIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 3,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0005 14C14.5974 14 15.1834 14.1283 15.6973 14.3714C15.9294 14.4812 16.1429 14.6126 16.3338 14.7623C16.5655 14.944 16.7638 15.1525 16.9215 15.382C17.2091 15.8005 17.3509 16.2731 17.3322 16.7504C17.3134 17.2278 17.1348 17.6923 16.8149 18.0955C16.495 18.4988 16.0457 18.8259 15.5138 19.0427C14.9819 19.2595 14.3869 19.3581 13.7912 19.3281C13.1954 19.2981 12.6206 19.1406 12.1269 18.8722C11.6331 18.6038 11.2385 18.2342 10.9844 17.8021",
    stroke: "#667085",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.6665 14H19.3332",
    stroke: "#667085",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0159 10.1979C16.7618 9.76582 16.3672 9.39624 15.8734 9.12781C15.3797 8.85937 14.8049 8.70194 14.2091 8.67195C13.6134 8.64196 13.0184 8.74052 12.4865 8.95734C11.9546 9.17415 11.5053 9.50126 11.1854 9.90448C10.8655 10.3077 10.6869 10.7723 10.6681 11.2496C10.6627 11.3894 10.6709 11.5289 10.6926 11.6667",
    stroke: "#667085",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossedIcon);
export default __webpack_public_path__ + "static/media/crossed-icon.02657e6cd13d38e3b9b2645d38af7b11.svg";
export { ForwardRef as ReactComponent };